import React, { useState, useEffect } from "react";
import { capitalizeWords } from './helper/CapitalizeWords'
import { FormatMoney } from '../../../Helpers/FormatNumber'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { ModalImagen } from './ModalImagen';
import { ModalUtilidadMargen } from "./ModalUtilidadMargen";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { ModalModificarTodo } from "./ModalModificarTodo";
import { ModalPromociones } from "./ModalPromociones";
import { ModalAgregarPromociones } from "./ModalAgregarPromociones";
import { ModalModificarImagen } from "./ModalModificarImagen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import { ModalModificarTotalPromociones } from "./ModalModificarTotalPromociones";
import { ModalCarruselImagenes } from "../ListadoPrecios/ModalCarruselImagenes";
import CollectionsIcon from '@mui/icons-material/Collections';
import { useRef } from "react";
import AspersoraIcon from "../../../Styles/ProductoAliado/aspersor.png"
import RemolqueIcon from "../../../Styles/ProductoAliado/Remolque.png"
import MolinoIcon from "../../../Styles/ProductoAliado/molino.png"
import FertilizacionIcon from "../../../Styles/ProductoAliado/arado.png"
import { EnviarNotificacion } from "../../helpers/EnviarNotificacion";


export const TablaConfListadoPrecioContainer = ({ datos, ObtenerListado, filtrar, setFiltrar, setKeyFiltrado, reseteoFiltro }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalCarrusel, setOpenModalCarrusel] = useState(false);
  const [openModalModificarImg, setOpenModalModificarImg] = useState(false);
  const [imagenes, setImagenes] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openModalUtilidadMargen, setOpenModalUtilidadMargen] = useState(false);
  const [openModalAgregarPromo, setOpenModalAgregarPromo] = useState(false);
  const [openModalModificarPromo, setOpenModalModificarPromo] = useState(false);
  const [openModalModificarTodo, setopenModalModificarTodo] = useState(false);
  const [openModalModificarPromociones, setOpenModificarPromociones] = useState(false)
  const containerRef = useRef(null);

  // console.log(datos)

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [nuevaData, setNuevaData] = useState([])


  const handleOpenUtilidadMargen = (rowData) => {
    setSelectedRow(rowData);
    setOpenModalUtilidadMargen(true);
  };
  const handleCloseUtilidadMargen = () => setOpenModalUtilidadMargen(false);

  const handleOpenAgregarPromo = (rowData) => {
    setSelectedRow(rowData);
    setOpenModalAgregarPromo(true);
  };

  const handleOpenCarrusel = async (rowData, imagen) => {
    // console.log(imagen)
    if (imagen === "N") {
      return
    }
    else {
      setSelectedRow(rowData);
      setLoader({ ...loader, mostrar: true });

      try {
        const result = await request.get(`ImagenesProductoAliado/BuscarImagenes?idinventario=${rowData.idinventario}`);

        if (result && result.length > 0) {
          setImagenes(result);
          setOpenModalCarrusel(true);
          setLoader({ ...loader, mostrar: false });
        } else {
          Swal.fire("Imagenes", "Este producto no cuenta con imagenes", "warning");
          setLoader({ ...loader, mostrar: false });
        }
      } catch (error) {
        console.error(error);
      }
    }

  };
  const handleCloseCarrusel = () => setOpenModalCarrusel(false);

  const handleCloseAgregarPromo = () => {
    setOpenModalAgregarPromo(false);
  };

  const handleCloseModificarAllPromo = () => {
    setOpenModificarPromociones(false);
  };

  const handleOpenModificarPromo = (rowData) => {
    setSelectedRow(rowData);
    setOpenModalAgregarPromo(true);
  };

  const handleOpenPromoModal = (rowData) => {
    setSelectedRow(rowData);
    if (rowData.promocion) {
      setOpenModalModificarPromo(true); // Si ya tiene promoción, abre modificar
    } else {
      setOpenModalAgregarPromo(true); // Si no tiene promoción, abre agregar
    }
  };

  const handleOpenModificarAllPromo = (rowData) => {
    setSelectedRow(rowData);
    setOpenModificarPromociones(true); // Si no tiene promoción, abre agregar
  };

  const handleCloseModificarPromo = () => {
    setOpenModalModificarPromo(false);
  };

  const handleOpen = async (rowData) => {
    setSelectedRow(rowData);
    setLoader({ ...loader, mostrar: true });

    try {
      const result = await request.get(`ImagenesProductoAliado/BuscarImagenes?idinventario=${rowData.idinventario}`);

      if (result && result.length > 0) {
        setImagenes(result);
        setOpenModal(true);
        setLoader({ ...loader, mostrar: false });
      } else {
        setImagenes([]);
        setOpenModal(true);
        setLoader({ ...loader, mostrar: false });
      }
    } catch (error) {
      console.error(error);
      setOpenModal(true);
    }
  };

  // console.log(imagenes)


  const handleOpenModificarTodo = () => {
    setopenModalModificarTodo(true);
  };
  const handleCloseModificarTodo = () => setopenModalModificarTodo(false);

  const handleClose = () => setOpenModal(false);
  const handleCloseModificarImg = () => setOpenModalModificarImg(false);

  const onEstatus = (estatus) => {
    if (estatus === "L") {
      return "info-estatus-circulo circulo-verde"
    }
    else if (estatus === "A") {
      return "info-estatus-circulo circulo-amarillo"
    }
    else if (estatus === "V") {
      return "info-estatus-circulo circulo-rojo"
    }
  }

  const ActualizarMargen = (e, id) => {
    const nuevoMargen = e.target.value; // Obtener el nuevo valor del margen

    // Verificar si el ítem ya está en nuevaData
    setNuevaData(prevData => {
      const itemIndex = prevData.findIndex(item => item.idinventario === id); // Usamos idinventario para la comparación

      if (itemIndex !== -1) {
        // Si ya existe el ítem en nuevaData, actualizamos el objeto completo con el margen actualizado
        return prevData.map(item =>
          item.idinventario === id
            ? { ...item, margen: nuevoMargen, precio_lista: (item.costo_total / (1 - (nuevoMargen / 100))).toFixed(2), utilidad: (((item.costo_total / (1 - (nuevoMargen / 100)))) - item.costo_total).toFixed(2) } // Actualizamos el margen, pero mantenemos todo el objeto
            : item
        );
      } else {
        // Si no existe el ítem, agregamos el ítem completo desde datos con el margen modificado
        const itemToUpdate = datos.find(item => item.idinventario === id); // Obtener el ítem de datos
        return [...prevData, { ...itemToUpdate, margen: nuevoMargen, precio_lista: (itemToUpdate.costo_total / (1 - (nuevoMargen / 100))).toFixed(2), utilidad: (((itemToUpdate.costo_total / (1 - (nuevoMargen / 100)))) - itemToUpdate.costo_total).toFixed(2) }]; // Agregar el ítem completo con el margen actualizado
      }
    });
  };

  const ActualizarUtilidad = (e, id) => {
    const nuevaUtilidad = e.target.value.replace(/[^0-9.]/g, ''); // Obtener el nuevo valor del margen

    // Verificar si el ítem ya está en nuevaData
    setNuevaData(prevData => {
      const itemIndex = prevData.findIndex(item => item.idinventario === id); // Usamos idinventario para la comparación

      if (itemIndex !== -1) {
        // Si ya existe el ítem en nuevaData, actualizamos el objeto completo con el margen actualizado
        return prevData.map(item =>
          item.idinventario === id
            ? { ...item, utilidad: nuevaUtilidad, precio_lista: (item.costo_total + Number(nuevaUtilidad)).toFixed(2), margen: ((nuevaUtilidad * 100) / (item.costo_total + Number(nuevaUtilidad))).toFixed(2) } // Actualizamos el margen, pero mantenemos todo el objeto
            : item
        );
      } else {
        // Si no existe el ítem, agregamos el ítem completo desde datos con el margen modificado
        const itemToUpdate = datos.find(item => item.idinventario === id); // Obtener el ítem de datos
        return [...prevData, { ...itemToUpdate, utilidad: nuevaUtilidad, precio_lista: (itemToUpdate.costo_total + Number(nuevaUtilidad)).toFixed(2), margen: ((nuevaUtilidad * 100) / (itemToUpdate.costo_total + Number(nuevaUtilidad))).toFixed(2) }]; // Agregar el ítem completo con el margen actualizado
      }
    });
  };

  const ActualizarPrecioLista = (e, id) => {
    const nuevoPrecioLista = e.target.value.replace(/[^0-9.]/g, ''); // Obtener el nuevo valor del margen

    // Verificar si el ítem ya está en nuevaData
    setNuevaData(prevData => {
      const itemIndex = prevData.findIndex(item => item.idinventario === id); // Usamos idinventario para la comparación

      if (itemIndex !== -1) {
        // Si ya existe el ítem en nuevaData, actualizamos el objeto completo con el margen actualizado
        return prevData.map(item =>
          item.idinventario === id
            ? { ...item, utilidad: (nuevoPrecioLista - item.costo_total).toFixed(2), precio_lista: (nuevoPrecioLista), margen: (((nuevoPrecioLista - item.costo_total) * 100) / (item.costo_total + Number(nuevoPrecioLista - item.costo_total))).toFixed(2) } // Actualizamos el margen, pero mantenemos todo el objeto
            : item
        );
      }
      else {
        // Si no existe el ítem, agregamos el ítem completo desde datos con el margen modificado
        const itemToUpdate = datos.find(item => item.idinventario === id); // Obtener el ítem de datos
        return [...prevData, { ...itemToUpdate, utilidad: (nuevoPrecioLista - itemToUpdate.costo_total).toFixed(2), precio_lista: nuevoPrecioLista, margen: (((nuevoPrecioLista - itemToUpdate.costo_total) * 100) / (itemToUpdate.costo_total + Number(nuevoPrecioLista - itemToUpdate.costo_total))).toFixed(2) }]; // Agregar el ítem completo con el margen actualizado
      }
    });
  };

  const formatWithCommas = (value) => {
    if (!value) return '';
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  // console.log(nuevaData)

  const onFiltrar = (filtro) => {
    setFiltrar(!filtrar)
    setKeyFiltrado(filtro)
  }

  const onGuardar = () => {
    // Extraer solo los campos necesarios
    const datosFiltrados = nuevaData.map(({ idinventario, margen, utilidad, precio_lista }) => ({
      idinventario,
      margen,
      utilidad,
      precio_lista
    }));

    const post = { datosActualizados: datosFiltrados };

    setLoader({ ...loader, mostrar: true });

    request
      .post("ListadoPreciosProductoAliado/ActualizarTodosPrecio", post)
      .then(() => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Éxito", "Datos actualizados correctamente", "success");
        setNuevaData([]);
        ObtenerListado();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Error", JSON.stringify(error), "error");
      });
  };


  const onActualizar = () => {
    const datosActualizar = nuevaData.length > 0 ? nuevaData : datos;
    const tieneProductoSinPromocion = datosActualizar.some(producto => !producto.promocion);


    setLoader({ ...loader, mostrar: true });

    if (tieneProductoSinPromocion) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("Error", "Hay un producto sin promoción en el listado que intenta actualizar.", "error");
    }
    else {
      request
        .post("ListadoPreciosProductoAliado/ActualizarListadoPrecio", datosActualizar)
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Éxito", "Datos actualizados correctamente", "success");
          setNuevaData([]);
          ObtenerListado();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Error", JSON.stringify(error), "error");
        });
    }
  };

  const onCambioEstado = async (idinventario, estado) => {
    // console.log(idinventario)
    const nuevoEstado = estado === 'A' ? 'Listo para vender' : 'Acondicionando'
    const mensajeEstado = estado === 'A'
      ? "El estatus cambiará a 'Listo para vender'"
      : "El estatus cambiará a 'Acondicionando'";

    const preguntaEstado = estado === 'A' ? "¿Esta seguro que quiere cambiar el estatus a 'Listo para vender'?" : "¿Esta seguro que quiere cambiar el estatus a 'Acondicionando'?"
    const confirmacion = await Swal.fire({
      title: preguntaEstado,
      text: mensajeEstado,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, Cambiar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmacion.isConfirmed) return;
    try {
      setLoader({ ...loader, mostrar: true });
      request
        .get(`ListadoPreciosProductoAliado/CambioEstado?idinventario=${idinventario}`)
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Éxito", `El estatus ha sido cambiado a '${nuevoEstado}'`, "success");
          ObtenerListado();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Error", JSON.stringify(error), "error");
        });
    } catch (error) {
      Swal.fire("Error", "No se pudo realizar el cambio de estatus", "error");
      return;
    }
  };

  const totalPrecio = datos.reduce((sum, item) => sum + item.precio, 0);
  const totalCosto = datos.reduce((sum, item) => sum + item.costo, 0);
  const totalOt = datos.reduce((sum, item) => sum + item.ot, 0);
  const totalCostoTotal = datos.reduce((sum, item) => sum + item.costo_total, 0);
  const totalUtilidad = datos.reduce((sum, item) => sum + (item.utilidad || 0), 0);
  const totalPrecioLista = datos.reduce((sum, item) => sum + (item.precio_lista || 0), 0);
  const margenTotal = totalCosto !== 0 ? (totalUtilidad / totalCosto) * 100 : 0;

  const formatMargen = (margen) => {
    return margen % 1 === 0 ? `${margen}.00` : margen.toFixed(2);
  };

  // Función para obtener el margen
  const getMargen = (idInventario, nuevaData, datos) => {
    const item = nuevaData.find(item => item.idinventario === idInventario);
    return item?.margen === "" ? "" : item?.margen ?? datos.margen.toFixed(2);
  };

  const familiasOrdenadas = ["Aspersoras", "Remolques", "Molinos", "Equipos de Fertilización"];

  const clasificarFamilia = (modelo) => {
    if (modelo.toLowerCase().includes("aspersora")) return "Aspersoras";
    if (modelo.toLowerCase().includes("remolque")) return "Remolques";
    if (modelo.toLowerCase().includes("molino")) return "Molinos";
    return "Equipos de Fertilización";
  };

  const datosAgrupados = datos.filter(dato => dato.estatus === "L" || dato.estatus === "A").reduce((acc, dato) => {
    const familia = clasificarFamilia(dato.modelo_descripcion);
    if (!acc[familia]) acc[familia] = [];
    acc[familia].push(dato);
    return acc;
  }, {});

  const [stickyHeaders, setStickyHeaders] = useState({});

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const rows = containerRef.current.querySelectorAll(".familia-header");
      let currentHeader = null;

      rows.forEach(row => {
        const rect = row.getBoundingClientRect();
        if (rect.top <= 60) { // Ajusta la altura según sea necesario
          currentHeader = row.innerText;
        }
      });

      setStickyHeaders(prevState => ({
        ...prevState,
        current: currentHeader,
      }));
    };

    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [containerRef.current]);

  const obtenerIconoFamilia = (familia) => {
    switch (familia) {
      case 'Aspersoras':
        // return <AgricultureOutlinedIcon />;
        return <img src={AspersoraIcon} alt="Aspersora" className="img-trilladora" />;
      case 'Remolques':
        return <img src={RemolqueIcon} alt="Remolque" className="img-trilladora" />;
      case 'Molinos':
        return <img src={MolinoIcon} alt="Molino" className="img-trilladora" />;
      default:
        return <img src={FertilizacionIcon} alt="Cabezal" className="img-trilladora" />;
    }
  };

  return (
    <div className="paliado-listado-precios-container">
      <LoaderScreen loader={loader} />

      <div className="listado-precios-container-table scroll">

        <table cellSpacing={0} cellPadding={0}>
          <thead>
            <tr>
              <th className='celda-circulo celda-fija-numero'>

              </th>
              <th className='celda-circulo celda-fija'>

              </th>
              <th className="celda celda-fija-img"></th>
              <th className="celda celda-fija-2">
                <div>SUCURSAL</div>
              </th>
              <th className="celda-fija-3">
                <div>MODELO</div>
              </th>
              <th className="celda-fija-4">
                <div>N. E.</div>
              </th>
              <th>
                <div>MARCA</div>
              </th>
              <th>
                <div>ANTIGUEDAD</div>
              </th>
              <th>
                <div>SERIE</div>
              </th>
              <th>
                <div>RECEPCION</div>
              </th>
              <th>
                <div>COSTO</div>
              </th>
              <th>
                <div>UTILIDAD</div>
              </th>
              <th>
                <div>MARGEN</div>
              </th>
              <th>
                <div>PRECIO DE LISTA</div>
              </th>
              <th>
                <div>PROMOCION</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {familiasOrdenadas.map(familia => (
              datosAgrupados[familia] ? (
                <React.Fragment key={familia}>
                  <tr className="familia-header sticky-familia">
                    {/* <td></td>
                    <td></td>
                    <td></td>
                    <td></td> */}
                    <td colSpan={5} className="celda-fija-familia">
                      <div className="celda-titulo-familia">
                        {obtenerIconoFamilia(familia)}
                        {familia.toUpperCase()}
                      </div>
                    </td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>
                    <td className="celda-familia"></td>

                  </tr>
                  {datosAgrupados[familia].map((datos, index) => (
                    <tr key={datos.id || index}>
                      <td className="celda-circulo celda-fija-numero">{index + 1}</td>
                      <td className="celda-circulo celda-fija">
                        <div className={onEstatus(datos.estatus)} onClick={() => onCambioEstado(datos.idinventario, datos.estatus)}></div>
                      </td>
                      <td className="celda-img celda-fija-img"><div className={datos.tiene_imagen === "S" ? "img" : "img-sin-color"} onClick={() => handleOpenCarrusel(datos, datos.tiene_imagen)}><CollectionsIcon /></div></td>
                      <td className="celda-sucursal ta-center celda-fija-2">{datos.nombre_sucursal}</td>
                      <td className="celda-modelo celda-fija-3">{datos.modelo_descripcion}</td>
                      <td className='celda-ne celda-fija-4'>{datos.ne}</td>
                      <td className="celda-marca">{datos.marca}</td>
                      <td className="celda-antiguedad">{datos.antiguedad} {datos.antiguedad === 1 ? "MES" : "MESES"}</td>
                      <td className="celda-serie">{datos.serie}</td>
                      <td className='celda-chica'>{datos.fecha_recepcion}</td>
                      <td className='celda-importe'>{datos.costo === 0 ? '-' : FormatMoney(datos.costo, 0)}</td>
                      <td className={'celda-importe'}
                        style={{ cursor: "pointer" }}>
                        <input
                          type="text"
                          className={(datos.utilidad < 0 || nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad < 0 ? 'red' : '')}
                          value={nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad === "" ? "" : formatWithCommas(nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad || datos.utilidad)}
                          onChange={(e) => ActualizarUtilidad(e, datos.idinventario)}
                          placeholder="%" // Indicando que es un porcentaje
                        />
                      </td>

                      <td className='celda-importe' style={{ cursor: "pointer" }}>
                        <input
                          // className="input-margen"
                          className={"input-margen " + (nuevaData.find(item => item.idinventario === datos.idinventario)?.utilidad < 0 || datos.utilidad < 0 ? 'red' : '')}
                          type="number"
                          value={getMargen(datos.idinventario, nuevaData, datos)}
                          onChange={(e) => ActualizarMargen(e, datos.idinventario)}
                          placeholder="%"
                        />
                        %
                      </td>


                      <td className='celda-importe' style={{ cursor: "pointer" }}>
                        <input
                          type="text"
                          value={nuevaData.find(item => item.idinventario === datos.idinventario)?.precio_lista === "" ? "" : formatWithCommas(nuevaData.find(item => item.idinventario === datos.idinventario)?.precio_lista || datos.precio_lista)}
                          onChange={(e) => ActualizarPrecioLista(e, datos.idinventario)}
                          placeholder="" // Indicando que es un porcentaje
                        />

                      </td>

                      <td className="celda-promocion">
                        <div className="celda-promocion-container" style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className={datos.promocion ? "promocion-button" : "sinpromocion-button"}
                            onClick={() => handleOpenPromoModal(datos)}
                            style={{ cursor: "pointer" }}
                          >
                            <LocalOfferIcon />
                            {datos.promocion ? '' : ' Promociones'}
                          </div>

                          <div>
                            {datos.promocion ? datos.promocion.toUpperCase() : ''}
                            <br />
                            {datos.vigencia ? datos.vigencia : ''}
                          </div>
                        </div>
                      </td>

                    </tr>
                  ))}
                  <tr>
                    <td colSpan={5}></td>
                    <td className="celda-fija-4 celda-total-grupo">Total:</td>
                    <td colSpan={4}></td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.costo, 0))}</td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.utilidad, 0))}</td>
                    <td className="celda-total-grupo-importe"> {(
                      datosAgrupados[familia].reduce((total, datos) => total + datos.utilidad, 0) /
                      datosAgrupados[familia].reduce((total, datos) => total + datos.precio_lista, 0) * 100
                    ).toFixed(2)} %</td>
                    <td className="celda-total-grupo-importe">{FormatMoney(datosAgrupados[familia].reduce((total, datos) => total + datos.precio_lista, 0))}</td>
                    <td></td>
                  </tr>
                </React.Fragment>
              ) : null
            ))}
            <tr className="fila-totales">
              <td colSpan={4}></td>
              <td className="celda-fija-4 celda-total-grupo">Totales:</td>
              <td colSpan={4}></td>
              <td className='celda-importe'>{FormatMoney(totalCosto, 0)}</td>
              <td className='celda-importe'>{FormatMoney(totalUtilidad, 0)}</td>
              <td className='celda-importe'>{FormatMoney((totalUtilidad / totalPrecioLista) * 100)}%</td>
              <td className='celda-importe'>{FormatMoney(totalPrecioLista, 0)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="listado-precios-footer-container">
        <div className="listado-precios-info-container">
          <div className="info-estatus">

            <div className="info-estatus-container-complete green" onClick={() => onFiltrar("L")}>
              <div className="info-estatus-circulo circulo-verde"></div>
              Listo para la venta
            </div>

            <div className="info-estatus-container-complete green" onClick={() => onFiltrar("A")}>
              <div className="info-estatus-circulo circulo-amarillo"></div>
              Acondicionando
            </div>

            <div className="info-estatus-container-complete green" onClick={() => onFiltrar("T")}>
              <div className="info-estatus-circulo circulo-dividido"></div>
              Todos
            </div>

          </div>
        </div>

        <div className="listado-precio-buttons-container">
          {nuevaData.length > 0 && (
            <div>
              <button className="listado-precios-button-guardar"
                onClick={() => onGuardar()}
              >
                <SaveIcon />
                Aplicar cambios
              </button>
            </div>
          )}

          <div>
            <button className="listado-precios-button-actualizar"
              onClick={() => onActualizar()}
            >
              <RestartAltIcon />
              Actualizar Listado
            </button>
          </div>

          <div>
            <button className="listado-precios-button-modificar-todo"
              onClick={() => handleOpenModificarTodo()}
            >
              <RestartAltIcon />
              Utilidad/Margen
            </button>
          </div>
          <div>
            <button className="listado-precios-button-modificar-promociones"
              onClick={() => handleOpenModificarAllPromo(datos)}
            >
              <LocalOfferIcon />
              Promociones
            </button>
          </div>
        </div>

      </div>
      <ModalImagen open={openModal} handleClose={handleClose} datos={selectedRow} imagenesBD={imagenes} />
      <ModalCarruselImagenes open={openModalCarrusel} handleClose={handleCloseCarrusel} datos={selectedRow} imagenesBD={imagenes} />

      <ModalModificarImagen open={openModalModificarImg} handleClose={handleCloseModificarImg} datos={selectedRow} imagenesBD={imagenes} />
      <ModalUtilidadMargen
        open={openModalUtilidadMargen}
        handleClose={handleCloseUtilidadMargen}
        datos={selectedRow}
        ObtenerListado={ObtenerListado}
      />
      <ModalPromociones
        open={openModalModificarPromo}
        handleClose={handleCloseModificarPromo}
        datos={selectedRow}
        ObtenerListado={ObtenerListado}
      />
      <ModalAgregarPromociones
        open={openModalAgregarPromo}
        handleClose={handleCloseAgregarPromo}
        datos={selectedRow}
        ObtenerListado={ObtenerListado}
      />
      <ModalModificarTodo
        open={openModalModificarTodo}
        handleClose={handleCloseModificarTodo}
        reseteoFiltro={reseteoFiltro}
        ObtenerListado={ObtenerListado}
        datos={datos}
      />

      <ModalModificarTotalPromociones
        open={openModalModificarPromociones}
        handleClose={handleCloseModificarAllPromo}
        reseteoFiltro={reseteoFiltro}
        datos={datos}
        ObtenerListado={ObtenerListado}
      />
    </div>
  )
}
